import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  result: undefined,
  error: undefined,
};

const change = (store, data) => {
  store.setState((state) => {
    state.cuenta.empresas.hits = {
      ...state.cuenta.empresas.hits,
      ...data,
    };
  });
};

const submit = async (store) => {
  store.setState((state) => {
    state.cuenta.empresas.hits.busy = true;
  });

  const data = {
    balance: [{ ...store.state.cuenta.empresas.hits.data }],
  };

  try {
    const response = await Http.post('/auth/me/hits', data);

    store.setState((state) => {
      state.cuenta.empresas.hits = {
        ...state.cuenta.empresas.hits,
        ...initialState,
        busy: false,
        data: response,
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.cuenta.empresas.hits.busy = false;
      state.cuenta.empresas.hits.error = error.data || error;
    });
  }
};

const reset = (store) => {
  const { empresas } = store.state;

  store.setState({
    empresas: {
      ...empresas,
      hits: {
        ...initialState,
      },
    },
  });
};

const EmpresaAsignacionHitsStore = {
  state: () => initialState,
  actions: {
    change,
    submit,
    reset,
  },
};

export default EmpresaAsignacionHitsStore;
